import React from 'react';
import {
  Button, ButtonText, Heading, Text, VStack,
} from '@gluestack-ui/themed';
import { useTranslation } from 'react-i18next';

/** The whole oral-exam task page once the exam is taken: nothing left to use. */
export const OralExamTakenNotice: React.FC<{ onBack: () => void }> = ({ onBack }) => {
  const { t } = useTranslation();
  return (
    <VStack space="md" px="$6" py="$8" maxWidth={560} testID="oral-exam-prep-taken">
      <Heading size="md">{t('oralExam.taken.title')}</Heading>
      <Text size="sm" color="$textBody">{t('oralExam.taken.body')}</Text>
      <Button
        variant="outline"
        size="sm"
        action="secondary"
        alignSelf="flex-start"
        onPress={onBack}
        testID="oral-exam-prep-taken-back"
      >
        <ButtonText color="$textBody">{t('oralExam.taken.back')}</ButtonText>
      </Button>
    </VStack>
  );
};
